import { render, staticRenderFns } from "./ToBranch.vue?vue&type=template&id=d1fc11e6&scoped=true"
import script from "./ToBranch.vue?vue&type=script&lang=js"
export * from "./ToBranch.vue?vue&type=script&lang=js"
import style0 from "./ToBranch.vue?vue&type=style&index=0&id=d1fc11e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1fc11e6",
  null
  
)

export default component.exports